/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfManageRoles } from '../../models/data-page-of-manage-roles';

export interface RolesList$Params {
  pageNumber?: number;
}

export function rolesList(http: HttpClient, rootUrl: string, params?: RolesList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfManageRoles>> {
  const rb = new RequestBuilder(rootUrl, rolesList.PATH, 'get');
  if (params) {
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfManageRoles>;
    })
  );
}

rolesList.PATH = '/roles/list';
